export const ProductType = {
  PRODUCT_GROUP: 'product_group',
  PRODUCT: 'product',
  PRODUCT_VARIANT: 'product_variant'
}; 